import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./style.scss"
const UiDrawer = ({
    title,
    onClose,
    open,
    size,
    extra,
    children,
    ...restProps
}) => {
    return <div>
        <Drawer
            title={title}
            onClose={onClose}
            closable={false}
            maskClosable={false}
            open={open}
            size={size}
            extra={extra}
            placement="right"
            {...restProps}
        >
            <CloseOutlined
                className="close-icon"
                style={{ color: "var(--text-on-secondary)" }}
                onClick={onClose}
            />
            {children}
        </Drawer>
    </div>
};
export default UiDrawer